// Copyright (c) StrangeBee 2024

import { TitleSection } from '@Atoms/TitleSection/TitleSection';
import { UseLocalMessageType } from '@Helpers/locale';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THPassword } from '@Molecules/Inputs/THPassword/THPassword';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { THForm } from '@Molecules/THForm/THForm';
import React, { ReactElement } from 'react';
import { AuthType } from 'thehive-sdk';

export const authOptions = [
    {
        type: 'none',
        label: 'None',
    },
    {
        type: 'basic',
        label: 'Basic',
    },
    {
        type: 'key',
        label: 'Key',
    },
    {
        type: 'bearer',
        label: 'Bearer',
    },
];

export const AuthFormItems = <T extends { auth?: AuthType }>({
    local,
    endpointTypeName,
}: {
    local: UseLocalMessageType;
    endpointTypeName?: string;
}): ReactElement => (
    <>
        {(!endpointTypeName || endpointTypeName !== 'slack') && (
            <>
                <TitleSection className="endpoint-manage__title-section">
                    {local('notification.form.auth.title')}
                </TitleSection>
                <THForm.Item name={['auth', 'type']} label={local('configProxy.field.auth-type.name')}>
                    <THSelect
                        options={authOptions.map(({ type, label }) => ({ label, value: type }))}
                        placeholder={local('configProxy.field.auth-type.placeholder')}
                    />
                </THForm.Item>
            </>
        )}
        <THForm.Item<T> noStyle shouldUpdate={(prev, next) => prev.auth?.type !== next.auth?.type}>
            {({ getFieldValue }) => (
                <>
                    <THForm.Item
                        name={['auth', 'username']}
                        label={local('configProxy.field.username.name')}
                        hidden={getFieldValue(['auth', 'type']) !== 'basic'}
                    >
                        <THInput placeholder={local('configProxy.field.username.placeholder')} />
                    </THForm.Item>

                    <THForm.Item
                        name={['auth', 'password']}
                        label={local('configProxy.field.password.name')}
                        hidden={getFieldValue(['auth', 'type']) !== 'basic'}
                    >
                        <THPassword placeholder={local('configProxy.field.password.placeholder')} />
                    </THForm.Item>

                    <THForm.Item
                        name={['auth', 'key']}
                        label={local('configProxy.field.key.name')}
                        hidden={!['key', 'bearer'].includes(getFieldValue(['auth', 'type']))}
                    >
                        <THInput placeholder={local('configProxy.field.key.placeholder')} />
                    </THForm.Item>
                </>
            )}
        </THForm.Item>
    </>
);
